enum AB_TEST_VARIANTS {
    WIDTH_1200_PX = 'width1200px',
    WIDTH_1500_PX = 'width1500px'
}

export const EXPERIMENT_ID = '5M7LhiWOQVa83MwmNC6pNw';
export const ACTIVATION_EVENT = 'optimize.activate';

export default AB_TEST_VARIANTS;
